<div class="modal-header mainColor">
	<h6 class="modal-title" *ngIf="from=='historic'">{{"historic.modal.title" | translate}}</h6>
	<h6 class="modal-title" *ngIf="from=='active'">{{"action_plan.modal.title" | translate}}</h6>
	<h6 class="modal-title" *ngIf="from=='save_plan'">{{"action_plan.modal_save.title" | translate}}</h6>
	<h6 class="modal-title" *ngIf="from=='historic_delete'">{{"historic.modal.title_delete" | translate}}</h6>
	<h6 class="modal-title" *ngIf="from=='save'">{{"action_plan.modal_save.title" | translate}}</h6>
	<h6 class="modal-title" *ngIf="from=='descartar'">{{"action_plan.modal_save.discard_title" | translate}}</h6>
	<h6 class="modal-title" *ngIf="from=='delete_method'">{{title}}</h6>
	<h6 class="modal-title" *ngIf="from=='add_new_action'">{{title}}</h6>
	<h6 class="modal-title" *ngIf="from=='add_method_changes'">{{title}}</h6>
	<h6 class="modal-title" *ngIf="from=='action_historic'">
		{{"action_plan.plan_development.modal_historic.modal_title" | translate}}</h6>
	<h6 class="modal-title" *ngIf="from=='delete_action'">
		{{"action_plan.plan_development.delete_action" | translate}}</h6>
	<h6 class="modal-title" *ngIf="from=='delete_selected'">
		{{"action_plan.plan_development.delete_actions" | translate}}</h6>
	<button type="button" class="close dangerButton" aria-label="Close" style="opacity: 1;" (click)="btnDismiss()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>
<div class="modal-body" ngbAutofocus>
	{{content}}

</div>
<div class="modal-footer">
	<ng-container *ngIf="from=='add_data' || from=='save_plan';else botones">
		<button class="btn m-2 dangerButton text-white" (click)="btnCancel()">
			{{ "globals.buttons.cancelar" | translate }}
		</button>
		<button type="button" class="btn dangerButton" (click)="btnDismiss()"> {{"button.no" | translate}}</button>
		<button type="button" class="btn acceptButton" (click)="btnClose()">{{"button.yes" | translate}}</button>

	</ng-container>
	<ng-template #botones>
		<button type="button" class="btn dangerButton" (click)="btnDismiss()"> {{"button.no" | translate}}</button>
		<button type="button" class="btn acceptButton" (click)="btnClose()">{{"button.yes" | translate}}</button>
	</ng-template>



</div>